
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import CustomDatePicker from './CustomDatePicker';
import GuestSelector from './GuestSelector';
import { useLanguage } from '@/contexts/LanguageContext';

interface SearchFormDesktopProps {
  checkIn?: Date;
  checkOut?: Date;
  guests: string;
  onCheckInChange: (date: Date | undefined) => void;
  onCheckOutChange: (date: Date | undefined) => void;
  onGuestsChange: (value: string) => void;
  onSearch: () => void;
  maxGuests?: number;
  unavailableDates?: Date[];
}

const SearchFormDesktop = ({
  checkIn,
  checkOut,
  guests,
  onCheckInChange,
  onCheckOutChange,
  onGuestsChange,
  onSearch,
  maxGuests = 6,
  unavailableDates = []
}: SearchFormDesktopProps) => {
  const { t } = useLanguage();
  const [checkOutPickerOpen, setCheckOutPickerOpen] = useState(false);

  const handleCheckInChange = (date: Date | undefined) => {
    console.log('🔍 SearchFormDesktop - Check-in date selected:', date);
    
    // If check-out is selected and is before or equal to the new check-in, clear it
    if (date && checkOut && checkOut <= date) {
      console.log('🔄 SearchFormDesktop - Clearing check-out date (before new check-in)');
      onCheckOutChange(undefined);
    }
    
    // Always call the parent handler
    onCheckInChange(date);
  };

  const handleCheckOutChange = (date: Date | undefined) => {
    console.log('🔍 SearchFormDesktop - Check-out date selected:', date);
    onCheckOutChange(date);
    setCheckOutPickerOpen(false);
  };

  const handleAutoOpenCheckOut = () => {
    setCheckOutPickerOpen(true);
  };

  const handleCheckOutOpenChange = (open: boolean) => {
    setCheckOutPickerOpen(open);
  };

  console.log('🏠 SearchFormDesktop render with dates:', {
    checkIn: checkIn?.toDateString(),
    checkOut: checkOut?.toDateString(),
    guests
  });

  return (
    <div className="hidden md:grid md:grid-cols-4 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">{t('home.hero.checkin')}</label>
        <CustomDatePicker 
          selected={checkIn} 
          onSelect={handleCheckInChange} 
          placeholder="Agregar fecha"
          autoOpenNext={handleAutoOpenCheckOut}
          title="Fecha de entrada"
          unavailableDates={unavailableDates}
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">{t('home.hero.checkout')}</label>
        <CustomDatePicker 
          selected={checkOut} 
          onSelect={handleCheckOutChange} 
          placeholder="Agregar fecha"
          minDate={checkIn ? new Date(checkIn.getTime() + 24 * 60 * 60 * 1000) : new Date()}
          open={checkOutPickerOpen}
          onOpenChange={handleCheckOutOpenChange}
          title="Fecha de salida"
          unavailableDates={unavailableDates}
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t('home.hero.guests')}
        </label>
        <GuestSelector
          value={guests}
          onChange={onGuestsChange}
          maxGuests={maxGuests}
          className="h-12"
          placeholder="Huéspedes"
        />
      </div>
      
      <div className="flex items-end">
        <Button onClick={onSearch} className="w-full h-12 text-white rounded-xl bg-blue-600 hover:bg-blue-500">
          Buscar
        </Button>
      </div>
    </div>
  );
};

export default SearchFormDesktop;
